<template>
    <div>
        <div class="k-offsetbar inapp-show"></div>
        <div class="summary__race__wrapper" :style="{top:pos_top_bar}">
            <div class="container">
                <div class="row">
                    <div class="col-12 summary__race__wrapper__content">
                        <div class="summary__race__wrapper__content__left">
                            <p class="summary__race__wrapper__content__left__title">{{ race_name }}</p>
                            <p class="summary__race__wrapper__content__left__race_name">{{ titolo }}</p>
                            <p class="summary__race__wrapper__content__left__race_maglia" style="color:#C8277D" v-if="iscrizione && conMaglia">{{ titolo_maglia }}</p>
                        </div>
                        <div v-if="team"><a :href="url_team" class="btn-race" target="_blank">Squadra {{team.name}}</a></div>
                        <div class="summary__race__wrapper__content__right" v-if="num_iscritti > 0" @click="show_modal">
                            <div>{{ num_iscritti }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal size="lg" ref="riassunto" class="modal__race" lazy hide-footer>
            <div class="modal__race__heading">
                <div class="modal__race__heading__title" style="color:#C8277D">Riepilogo iscrizioni</div>
            </div>
            <div class="modal_race__items--wrapper">
                <div class="modal_race__items--wrapper__heading">
                    <div class="modal_race__items--wrapper__heading__title">Partecipanti</div>
                    <div class="modal_race__items--wrapper">
                        <div class="modal_race__items--wrapper__item">
                            <b-link class="modal_race__items--wrapper__item__add-wrapper" @click="new_record">
                                <div class="float-left text-uppercase small">Aggiungi nuovo</div>
                                <!--<div class="icon-wrapper float-right"><span class="icon"></span></div>-->
                            </b-link>
                        </div>
                    </div>
                </div>
                <div class="modal_race__items--wrapper__item mb-1" v-for="(iscritto, num) in iscritti" :key="num">
                    <div class="modal_race__items--wrapper__item__data">
                        <div class="text-dark"><b>{{ iscritto.nome }} {{ iscritto.cognome }}</b></div>
                        <div class="text-primary" v-if="iscritto.societa">Società {{ iscritto.societa }}</div>
                        <div class="text-primary" v-if="team">Squadra {{ team.name }}</div>
                        <div class="text-secondary">{{ iscritto.email }}</div>
                        <div class="text-secondary">Categoria {{ iscritto.categoria_show }}</div>
                        <div class="text-primary" v-if="iscritto.maglia">Riceverà subito la maglia e lo zainetto a domicilio</div>
                        <div v-else class="text-primary">Ritirerà il kit race con la maglia al Villaggio Race</div>
                        <div class="opacity-05 font-italic text-secondary">{{ iscritto.data_nascita }}</div>

                        <div class="modal_race__items--wrapper__item__features-list">
                            <div class="modal_race__items--wrapper__item__features-list__item">
                                <span v-if="iscritto.taglia_minore" class="text-secondary opacity-05 font-italic">Taglia {{ iscritto.taglia_minore }}<span
                                        class="small font-weight-bold pl-1 text-secondary opacity-05 font-italic">[Bambino]</span></span>
                                <span v-if="iscritto.taglia" class="opacity-05 text-secondary">Taglia {{ iscritto.taglia }}</span>
                            </div>
                            <div class="modal_race__items--wrapper__item__features-list__item">
                                <img class="modal_race__items--wrapper__item__features-list__item__img" height="30"
                                     src="/static/svg/icons/money.svg">
                                <span class="font-weight-bold text-primary">Donazione di Euro {{ iscritto.totale }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal_race__items--wrapper__item__actions">
                        <b-link @click="edit(iscritto.id)">
                            <img class="modal_race__items__wrapper__item__features-list__item__img" height="15"
                                 src="/static/svg/icons/icon-edit.svg">
                        </b-link>
                        <b-link class="text-secondary ml-3" @click="del_iscritto(iscritto.id)">
                            <img class="modal_race__items__wrapper__item__features-list__item__img ml-2" height="15"
                                 src="/static/svg/icons/icon-delete.svg">
                        </b-link>
                    </div>
                </div>
            </div>

            <div class="modal_race__items--wrapper" v-if="maglia">
                <div class="modal_race__items--wrapper__heading">
                    <div class="modal_race__items--wrapper__heading__title">Indirizzo di spedizione </div>
                </div>
                <div class="modal_race__items--wrapper__item">
                    <div class="modal_race__items--wrapper__item__data w-100">
                        <div class="d-flex align-items-center justify-content-between">
                            <span class="text-dark">{{maglia.nome}} {{maglia.cognome}}</span>
                            <b class="mr-1 small text-uppercase">Nome</b>
                        </div>
                    </div>
                </div>
                <div class="modal_race__items--wrapper__item">
                    <div class="modal_race__items--wrapper__item__data w-100">
                        <div class="d-flex align-items-center justify-content-between">
                            <span class="text-dark">{{maglia.cellulare}}</span>
                            <b class="mr-1 small text-uppercase pull-right">Telefono</b>
                        </div>
                    </div>
                </div>
                <div class="modal_race__items--wrapper__item">
                    <div class="modal_race__items--wrapper__item__data w-100">
                        <div class="d-flex align-items-center justify-content-between">
                            <span class="text-dark">{{maglia.indirizzo}}</span>
                            <b class="mr-1 small text-uppercase">Indirizzo</b>
                        </div>
                    </div>
                </div>
                <div class="modal_race__items--wrapper__item">
                    <div class="modal_race__items--wrapper__item__data w-100">
                        <div class="d-flex align-items-center justify-content-between">
                            <span class="text-dark">{{maglia.citta}} &mdash; {{maglia.cap}} ({{maglia.provincia}})</span>
                            <b class="mr-1 small text-uppercase">Città</b>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal_race__items--wrapper mt-3">
                <div class="modal_race__items--wrapper__heading">
                    <div class="modal_race__items--wrapper__heading__title">Importo donazioni</div>
                </div>
                <div class="modal_race__items--wrapper__item line-class">
                    <div class="modal_race__items--wrapper__item__data">
                        <div class="text-dark"><b>Totale per Iscrizione <span
                                class="text-primary">Race for the Cure</span></b></div>
                    </div>
                    <div class="modal_race__items--wrapper__heading__actions text-dark"><b><span class="font-weight-bold small">Euro</span>
                        {{ tot_donminima }}</b></div>
                </div>
                <div class="modal_race__items--wrapper__item line-class" v-if="tot_donaggiuntiva > 0">
                    <div class="modal_race__items--wrapper__item__data text-dark">
                        <div><b>Totale donazione aggiuntiva</b></div>
                    </div>
                    <div class="modal_race__items--wrapper__heading__actions text-dark"><b><span class="font-weight-bold small">Euro</span>
                        {{ tot_donaggiuntiva }}</b></div>
                </div>
                <div class="modal_race__items--wrapper__item line-class">
                    <div class="modal_race__items--wrapper__item__data"></div>
                    <div class="modal_race__items--wrapper__heading__actions text-primary text-uppercase h6"><b><span
                            class="font-weight-bold small">Totale Euro</span> {{totale}}</b></div>
                </div>



                <div class="form-row mt-4 px-3 bg-light text-center d-inline-block py-4 w-100 rounded" >

                    <div class="col-md-12" v-if="totale > 0">
                        <div class="mb-2 small font-weight-bold text-secondary">Seleziona la modalità di pagamento</div>
                    </div>
                    <div class="d-inline-block payment_select" v-if="totale > 0">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="paypal_selected" name="metodo_pagamento"
                                   class="custom-control-input"
                                   value="PAYPAL"
                                   v-model="tipo_pagamento"
                            >
                            <label class="custom-control-label" for="paypal_selected">
                                <img src="/static/svg/icons/paypal.svg" height="40">
                            </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="gestpay_selected" name="metodo_pagamento"
                                   class="custom-control-input"
                                   value="GESTPAY"
                                   v-model="tipo_pagamento"
                            >
                            <label class="custom-control-label text-dark" for="gestpay_selected">
                                <img src="/static/svg/icons/credit_card.svg" height="40"> <span class="small">Carta di credito</span>
                            </label>
                        </div>


<!--                        &lt;!&ndash;<div class="custom-control custom-radio custom-control-inline">&ndash;&gt;-->
<!--                        &lt;!&ndash;<input type="radio" id="bonifico_selected" name="metodo_pagamento"&ndash;&gt;-->
<!--                        &lt;!&ndash;class="custom-control-input"&ndash;&gt;-->
<!--                        &lt;!&ndash;value="BONIFICO"&ndash;&gt;-->
<!--                        &lt;!&ndash;v-model="tipo_pagamento"&ndash;&gt;-->
<!--                        &lt;!&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;<label class="custom-control-label d-flex align-items-center small" for="bonifico_selected">Bonifico&ndash;&gt;-->
<!--                        &lt;!&ndash;bancario</label>&ndash;&gt;-->
<!--                        &lt;!&ndash;</div>&ndash;&gt;-->
                   </div>
                    <div class="w-100 mt-3">
                        <div class="btn btn-sm btn-outline-secondary v-step__next-btn font-weight-bold text-uppercase mr-5"
                             @click="close_modal">Indietro
                        </div>
                        <div class="btn btn-sm v-step__next-btn btn-primary font-weight-bold text-uppercase"
                             @click="dona" :class="{loader: loader_dona}">Dona ora
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>

</template>

<script>
    import {events} from './events'

    export default {
        name: "Riassunto",
        props: ['iscrizione'],
        data() {
            return {
                tipo_pagamento: null,
                loader_dona: null,
                pos_top_bar: '175px',
                functionRef: null
            }
        },
        mounted() {
            events.$on('show_modal', this.show_modal);
            window.addEventListener('scroll', this.calcolaPosTop)
            this.calcolaPosTop()
        },
        destroyed() {
            window.removeEventListener('scroll', this.calcolaPosTop)
        },
        methods: {
            close_modal() {
                if (this.$refs && this.$refs.riassunto)
                    this.$refs.riassunto.hide()
            },
            show_modal(data) {
                this.functionRef = data
                if (this.$refs && this.$refs.riassunto)
                    this.$refs.riassunto.show()
            }, edit(id_iscritto) {
                let num_form = this.$store.getters.get_form_by_id(id_iscritto)
                if (num_form === false) {
                    console.log('ID Iscritto non trovato - ' + id_iscritto)
                    return false
                }
                this.$router.push({
                    name: 'inserimento-dati',
                    params: {id: num_form}
                })
                this.$refs.riassunto.hide()
            }, del_iscritto(id_iscritto) {
                let num_form = this.$store.getters.get_form_by_id(id_iscritto)
                this.$http.delete('/race/form/inserimento_dati?id=' + id_iscritto)
                    .then(response => {
                        if (response.data.success) {
                            this.$store.commit('del_form', {num_form: num_form})
                            this.$notify({text:'Iscritto eliminato con successo',duration:10})

                            if (this.iscritti <= 0) {
                                this.$router.push({name: 'first-choice'})
                            }
                        } else {
                            this.$notify({text:'Non è stato possibile eliminare questa iscrizione',duration:10,type:'warn'})
                        }
                    }, error => {
                        this.$notify({text:'Si è verificato un errore nel processare la tua richiesta, riprova tra poco',duration:10,type:'warn'})
                        console.log(error)
                    })

            }, dona() {
                let ids = []
                let iscritti = this.iscritti
                for (let i = 0; i < iscritti.length; i++)
                    ids.push(iscritti[i].id)
                this.loader_dona = true
                if (this.$route.name === 'inserimento-dati') {
                    window.removeEventListener('beforeunload', this.functionRef);
                }
                this.$http.defaults.headers.common['X-CSRFToken'] = this.$cookies.get('csrftoken')
                if(this.totale === 0){
                    this.$http.get('/race/form/selezione_team/?type=get_wire_info'  +
                                '&id_team=' + this.$store.getters.team.id +
                                '&id_race=' + this.id_race
                            ).then(response => {
                                this.$http.post('/race/form/donazione', {ids: ids, id_race: this.id_race, metodo: "WIRETRANSFER", wire_transfer: response.data.teams[0].wire_transfer, team_id: response.data.teams[0].id, wire_transfer_register_limit: response.data.teams[0].wire_transfer_register_limit, registered_users: response.data.teams[0].registered_users})
                                    .then(response => {
                                        this.loader_dona = false
                                        if (response.data.error)
                                            this.$notify({text:response.data.error,duration:10,type:'warn'})
                                        else
                                            window.location.replace(response.data.redirect)
                                    }, error => {
                                        this.loader_dona = false
                                        this.$notify({text:'Si è verificato un errore nel processare la tua richiesta, riprova tra poco',duration:10,type:'warn'})
                                        console.log(error)
                                    })
                                }, () => {
                                    this.$notify({text:'C\'è stato un problema nel processare la tua richiesta, riprova più tardi',duration:10,type:'warn'})
                                })
                    return
                }

                if(this.$store.getters.team){
                    this.$http.get('/race/form/selezione_team/?type=get_wire_info'  +
                        '&id_team=' + this.$store.getters.team.id +
                        '&id_race=' + this.id_race
                    ).then(response => {
                        console.log(response)
                        this.$http.post('/race/form/donazione', {ids: ids, id_race: this.id_race, metodo: this.tipo_pagamento, wire_transfer: response.data.teams[0].wire_transfer, team_id: response.data.teams[0].id,wire_transfer_register_limit: response.data.teams[0].wire_transfer_register_limit, registered_users: response.data.teams[0].registered_users })
                            .then(response => {
                                this.loader_dona = false
                                if (response.data.error)
                                    this.$notify({text:response.data.error,duration:10,type:'warn'})
                                else
                                    window.location.replace(response.data.redirect)
                            }, error => {
                                this.loader_dona = false
                                this.$notify({text:'Si è verificato un errore nel processare la tua richiesta, riprova tra poco',duration:10,type:'warn'})
                                console.log(error)
                            })
                        }, () => {
                            this.$notify({text:'C\'è stato un problema nel processare la tua richiesta, riprova più tardi',duration:10,type:'warn'})
                        })
                } else {
                        this.$http.post('/race/form/donazione', {ids: ids, id_race: this.id_race, metodo: this.tipo_pagamento, wire_transfer: false, team_id: null ,wire_transfer_register_limit: 0, registered_users: 0 })
                            .then(response => {
                                this.loader_dona = false
                                if (response.data.error)
                                    this.$notify({text:response.data.error,duration:10,type:'warn'})
                                else
                                    window.location.replace(response.data.redirect)
                            }, error => {
                                this.loader_dona = false
                                this.$notify({text:'Si è verificato un errore nel processare la tua richiesta, riprova tra poco',duration:10,type:'warn'})
                                console.log(error)
                            })
                        }

            }, new_record() {
                this.$router.push({
                    name: 'inserimento-dati',
                    params: {id: this.$store.getters.next_id_form}
                })
                this.$refs.riassunto.hide()
            }, calcolaPosTop() {
                let supportPageOffset = window.pageYOffset !== undefined
                let isCSS1Compat = ((document.compatMode || "") === "CSS1Compat")
                // Verifico di quanto siamo scrollati verticalmente
                let scrollY = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop

                // TODO; utilizzare degli ID invece che delle classi
                let height = 0
                let header = document.getElementsByClassName('k-header')
                if (header.length > 0)
                    height += header[0].clientHeight

                let navbar = document.getElementsByClassName('k-navbar')
                if (navbar.length > 0)
                    height += navbar[0].clientHeight

                let offsetBar = document.getElementsByClassName('k-offsetbar')
                let offset = 0
                if (offsetBar.length > 0)
                    offset = offsetBar[0].clientHeight


                this.pos_top_bar = (offset+(scrollY > height ? 0 : (height - scrollY ))) + 'px'
            }
        },
        computed: {
            is_wire_transfer() {
                return this.$store.getters.wire_transfer_method
            },iscritti() {
                return this.$store.getters.iscritti
            },maglia() {
                return this.$store.getters.maglia
            }, totale() {
                let totale = 0
                let iscritti = this.iscritti
                for (let i = 0; i < iscritti.length; i++)
                    totale += iscritti[i].totale

                return totale
            }, num_iscritti() {
                return this.iscritti.length
            },
            tot_donminima() {
                let totale = 0
                let iscritti = this.iscritti
                for (let i = 0; i < iscritti.length; i++)
                    totale += iscritti[i].base

                return totale
            }, tot_donaggiuntiva() {
                return this.totale - this.tot_donminima
            }, don_minima() {
                return this.$store.getters.donazione_base
            }, race_name() {
                return this.$store.getters.nome_race
            }, team() {
                return this.$store.getters.team
            }, id_race() {
                return this.$store.state.id_race
            }, url_team() {
                if (!this.team)
                    return ''
                return '/race/team/'+this.id_race+/detail/+this.team.id
            },partner_principale() {
                return this.$store.getters.partner_principale
            },partner_secondari() {
                return this.$store.getters.partner_secondari
            },race_logo() {
                return this.$store.getters.race_logo
            }, titolo() {
                return this.$store.getters.titolo_iniziale
            }, sottotitolo() {
                return this.$store.getters.sottotitolo_iniziale
            }, titolo_maglia() {
                return this.$store.getters.titolo_maglia
            }, conMaglia() {
                return this.$store.getters.con_maglia
            }
        }
    }
</script>

<style scoped>
.modal__race__heading__title[data-v-31266baa] {
    font-size: 1.75rem;
    font-weight: bold;
    margin: 0;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
    color: #C8277D;
    padding-left: 0.75rem;
}

.modal_race__items--wrapper__heading {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px black solid;
    padding-bottom: 0.5rem;
    margin-bottom: 4px;
}

.modal_race__items--wrapper__heading__title {
    color: black;
    text-transform: uppercase;
    font-weight: bold;
    font-size: larger;
}

.modal_race__items--wrapper__item.mb-1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.modal_race__items--wrapper__item {
    display: flex;
    justify-content: space-between;
    color: black;
}

.line-class {
    border-bottom: 1px solid lightgrey;
    padding: 5px 0px;
}
</style>
